(function (module) {
    'use strict';

    function starryNightDirective(lightUpTheSky) {
        return {
            restrict: 'A',
            scope: {
                stars: '@starryNight'
            },
            link: function (scope, element) {
                scope.sky = lightUpTheSky.withStars(scope.stars, element);
            }
        };
    }

    function lightUpTheSky() {

        // Private methods and variables
        var i = 0;
        var tries = 0;
        var intGridSpaceSize = 30; // {css} Background size per grid item
        var intStarSize = 6; // {css} Initial size of each star
        var proximityOptions = ['near', 'far']; // {css} Proximity options
        var intGridSpaceCenter = ((intGridSpaceSize - intStarSize) / 2);
        var starsInGrid = [];

        function init(numberOfStars, element) {

            function addStarsToGridMap() {

                var x;
                var y;
                var coordinates;

                while (i < numberOfStars) {
                    x = (intGridSpaceSize * (randomIntInRange(1, Math.floor(window.innerWidth / intGridSpaceSize)) - 1)) + intGridSpaceCenter;
                    y = (intGridSpaceSize * (randomIntInRange(1, Math.floor(window.innerHeight / intGridSpaceSize)) - 1)) + intGridSpaceCenter;
                    coordinates = [x, y];
                    if (outsideOfOtherStarsRange(starsInGrid, coordinates)) {
                        starsInGrid.push(coordinates);
                        i++;
                    } else {
                        tries++;
                        // Attempt to add this particular star up to 3 times, then move onto the next star
                        if (tries > 2) {
                            i++;
                            tries = 0;
                        }
                        addStarsToGridMap();
                    }


                }
            }

            // Check the star isn't too close to toher stars
            function outsideOfOtherStarsRange(starsArr, coordinates) {
                if (!starsArr.length) {
                    return true;
                } else {
                    return starsArr.every(function (arrayItem) {
                        var x = coordinates[0];
                        var y = coordinates[1];
                        return ((x + intGridSpaceSize) < arrayItem[0] || (x - intGridSpaceSize) > arrayItem[0]) &&
                            ((y + intGridSpaceSize) < arrayItem[1] || (y - intGridSpaceSize) > arrayItem[1]);
                    });
                }
            }

            // Inject the star into the DOM
            function createStar(left, top, proximity) {
                var star = document.createElement('star');
                star.setAttribute('animation', 'running');
                star.setAttribute('proximity', proximity);
                star.setAttribute('style', 'top: ' + top + 'px; left: ' + left + 'px; animation-delay: ' + randomIntInRange(0, 1000) + 'ms');
                //get current what ever directive element
                element.append(star);
            }

            // Generate a random number within a range
            function randomIntInRange(min, max) {
                return Math.floor(Math.random() * (max - min + 1) + min);
            }

            // Check the star isn't too close to toher stars
            function toggleAnimation() {
                [].forEach.call(document.querySelectorAll('star'), function (star) {
                    star.setAttribute('animation', star.getAttribute('animation') === 'running' ? 'paused' : 'running');
                });
            }

            // Remove all the stars on the page
            function removeStars() {
                [].forEach.call(document.querySelectorAll('star'), function (star) {
                    star.parentNode.removeChild(star);
                });
            }

            // Generate stars
            addStarsToGridMap();
            starsInGrid.forEach(function (star) {
                createStar(star[0], star[1], proximityOptions[randomIntInRange(0, proximityOptions.length - 1)]);
            });

            return {
                // Public methods and variables
                numberRequested: parseInt(numberOfStars),
                numberInViewport: starsInGrid.length,
                hide: toggleAnimation,
                remove: removeStars
            };

        }

        return {
            withStars: init
        };

    }

   module
        .factory('lightUpTheSky', lightUpTheSky)
        .directive('starryNight', starryNightDirective);

})(angular.module('rocket.components'));
